var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("ResourceEditor", {
        attrs: { viewModel: _vm.resourceEditor },
        on: { "form-submit": _vm.handleResourceEditorFormSubmit },
      }),
      _vm._v(" "),
      _c("CorporateNavigation", { attrs: { ActivePage: "resources" } }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "container-fluid",
          staticStyle: { "margin-top": "80px", "padding-top": "40px" },
        },
        [
          _c("div", { staticClass: "row" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-6 text-right align-self-end" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-success",
                  staticStyle: { padding: "0.7em 2em" },
                  attrs: { role: "button" },
                  on: { click: _vm.showResourceCreator },
                },
                [_vm._v("Create resource")]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("hr", {
            staticStyle: { "border-color": "#bbb", margin: "20px 0 60px" },
          }),
          _vm._v(" "),
          _vm.rm
            ? _c("div", { staticClass: "mt-3" }, [
                _c("div", { staticClass: "toolbar" }, [
                  _c("div", [
                    _c(
                      "div",
                      { staticClass: "btn-group", attrs: { role: "group" } },
                      [
                        _c(
                          "span",
                          { staticClass: "btn btn-secondary disabled" },
                          [
                            _vm._v(
                              "\n                            Resources\n                        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "sanitizedHref",
                                rawName: "v-sanitizedHref",
                                value: `/#/enterprise/resource-unit-costs/${_vm.workspaceId}/${_vm.strategyId}`,
                                expression:
                                  "`/#/enterprise/resource-unit-costs/${workspaceId}/${strategyId}`",
                              },
                            ],
                            staticClass: "btn btn-outline-secondary",
                          },
                          [
                            _vm._v(
                              "\n                            Unit costs\n                        "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div"),
                ]),
                _vm._v(" "),
                _c(
                  "table",
                  { staticClass: "table table-bordered table-hover" },
                  [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [_vm._v("Name")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Unit")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("P&L")]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(
                            "Cost per unit (" +
                              _vm._s(new Date().getFullYear()) +
                              ")"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("th", { staticStyle: { width: "120px" } }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.resourcesView, function (r) {
                        return _c("tr", { key: r.Id }, [
                          _c("td", [
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "sanitizedHref",
                                    rawName: "v-sanitizedHref",
                                    value: `/#/enterprise/resource-capacity/${_vm.workspaceId}/${_vm.strategyId}/${r.Id}`,
                                    expression:
                                      "`/#/enterprise/resource-capacity/${workspaceId}/${strategyId}/${r.Id}`",
                                  },
                                ],
                              },
                              [_vm._v(_vm._s(r.Name))]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(r.Unit))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(r.ExpenseClassification))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(_vm.fmtNum(r.CostPerUnit)) +
                                " " +
                                _vm._s(r.Currency)
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c("div", { staticClass: "dropdown" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary dropdown-toggle",
                                  attrs: {
                                    type: "button",
                                    "data-toggle": "dropdown",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                    Actions\n                                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-menu dropdown-menu-right",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.showResourceEditor(r)
                                        },
                                      },
                                    },
                                    [_vm._v("Edit")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleDeleteResourceCommand(
                                            r
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Delete")]
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ])
                      }),
                      0
                    ),
                  ]
                ),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-lg-6" }, [
      _c(
        "h1",
        {
          staticStyle: {
            "font-size": "2em",
            "font-weight": "300",
            color: "#33475b",
            margin: "0",
          },
        },
        [_vm._v("Resources")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }